import React from 'react';
import Header from '../../components/Header';
import SideNav from './SideNav';
import Footer from '../../components/Footer';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import UIFooter from '../../components/UIFooter';
const ReviewerLayout = () => {
  useEffect(() => {
    
    document.title = "Reviewer - Technical Paper Platform";
  }, []);
    return (
        <div className="wrapper">
        <Header />
        <SideNav />
  
        <div className="content-wrapper" style={{ minHeight: '100vh' }}>
          <section className="content pt-3 px-3">
            <div className="container-fluid">
            <Outlet />
            </div>
          </section>
        </div>
  
        <Footer />
      </div>
    );
};

export default ReviewerLayout;